import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import logo from '../assets/isil-logo.jpeg';
import '../styles/IsilCard.css';

const translations = {
  kz: {
    title: 'ISIL Ұлттық тіркеу агенттігі',
    summary: 'Қазақстан Республикасының Ұлттық кітапханасы еліміздің кітапханаларына халықаралық ISIL кодтарын береді.',
    introduction: 'Қазақстан Республикасының Ұлттық кітапханасы (NLRK) 2022 жылғы желтоқсаннан бастап Қазақстан Республикасының ISIL Ұлттық тіркеу агенттігі болып бекітілді және ресми тізімге енгізілді. Ұлттық агенттіктің қызметі Қазақстан Республикасының барлық кітапханаларына кітапханалық кодтарын беру болып табылады.',
    description: 'ISIL (кітапханалар мен онымен байланысты ұйымдарға арналған халықаралық стандартты идентификатор) кітапханаға, мұражайға, мұрағатқа немесе байланысты ұйымға берілуі мүмкін. ISIL-коды ISO 15511 стандартында ұйымдарды бірыңғай әлемдік ақпарат алмасу жүйесіне біріктіру құралы ретінде ұсынылған. ISIL-код кітапханалар мен ұйымдардың жазбаларына, құжаттарына және қызметтеріне, сондай-ақ халықаралық кітапхана дерекқорларына (каталогтарына) қол жеткізуді жеңілдету мақсатында сәйкестендіруге арналған.',
    contact: 'Кітапхана кодын тағайындау үшін хабарласыңыз:',
    phone: 'Телефон',
    more: 'Толығырақ',
    registry: 'ISIL ресми тізімі',
  },
  ru: {
    title: 'Национальное регистрационное агентство ISIL',
    summary: 'Национальная библиотека Республики Казахстан присваивает библиотекам страны международные коды ISIL.',
    introduction: 'Национальная библиотека Республики Казахстан (NLRK) с декабря 2022 года утверждена Национальным регистрационным агентством ISIL Республики Казахстан и включена в официальный список. Функция Национального агентства заключается в присвоении библиотечных кодов всем библиотекам Республики Казахстан.',
    description: 'ISIL (международный стандартный идентификатор для библиотек и связанных с ними организаций) может быть присвоен библиотеке, музею, архиву или связанной организации. ISIL-код представлен в стандарте ISO 15511, как инструмент интеграции организаций в единую мировую систему обмена информацией. ISIL-код предназначен для идентификации библиотек и организаций с целью упрощения доступа к их записям, документам и услугам, а также к международным библиотечным базам данных (каталогам).',
    contact: 'Для присвоения библиотечного кода обращаться:',
    phone: 'Телефон',
    more: 'Подробнее',
    registry: 'Официальный список ISIL',
  },
  en: {
    title: 'National registration agency ISIL',
    summary: 'The National Library of the Republic of Kazakhstan assigns international ISIL codes to libraries throughout the country.',
    introduction: 'National library of the Republic of Kazakhstan (NLRK) from December 2022 is approved by the National registration agency ISIL of the Republic of Kazakhstan and is included into the official list. The function of the National agency is in giving the library codes to all the libraries of the Republic of Kazakhstan.',
    description: 'ISIL (the international standard identifier for the libraries and organizations related with them) can be given to the library, museum, archive or related organization. The ISIL-code is presented in the standard ISO 15511 as the instrument for the integration of the organizations into the single world system for exchange of information. The ISIL-code is designed for the identification of the libraries and organizations with the purpose of simplification of access to their records, documents and services, and also to the international library data-bases (the catalogues).',
    contact: 'There for receiving the library code one is to address:',
    phone: 'The telephone',
    more: 'Read more',
    registry: 'Official ISIL register',
  },
};

export default function IsilCard() {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage] || translations.ru;

  return (
    <section className="isil-card" aria-labelledby="isil-title">
      <div className="isil-card-brand">
        <img src={logo} alt="ISIL Ұлттық тіркеу агенттігі" width="381" height="94" />
        <span>ISO 15511</span>
      </div>
      <h2 id="isil-title">{t.title}</h2>
      <p className="isil-card-summary">{t.summary}</p>
      <div className="isil-card-contact">
        <p>{t.contact}</p>
        <a href="tel:+77272672873"><span>{t.phone}:</span> +7 (727) 267 28 73</a>
        <a href="mailto:metod_nlrk@mail.kz"><span>Email:</span> metod_nlrk@mail.kz</a>
      </div>
      <details className="isil-card-details">
        <summary>{t.more}</summary>
        <div className="isil-card-description">
          <p>{t.introduction}</p>
          <a href="https://slks.dk/english" target="_blank" rel="noopener noreferrer">{t.registry} <span aria-hidden="true">↗</span></a>
          <p>{t.description}</p>
        </div>
      </details>
    </section>
  );
}
